import React, { Suspense,useState } from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import "./index.scss";
import { RecoilRoot,useRecoilValue } from "recoil";
import reportWebVitals from "./reportWebVitals";
import Login from "./pages/login";
import PresentationServices from "./pages/PresentationServices";

import Dashboard from "./pages/dashboard";
import { userDataState } from "./atoms/dashboard";
import Landing from "./pages/landing";
import NotFound from "./pages/NotFound";
import ExploreOpportunities from "./components/ExploreOpportunities/ExploreOpportunities";
import JourneyMap from "./pages/JourneyMap";
import { data } from "./utils/exploreoppdata";
import LoadPages from "./main";
import Help from "./pages/help";
export const Loading = () => {
  // return <div className="loader mx-auto  mt-14 grid place-items-center">
  // </div>;
  return <div className="loader_outer"><div className="newloader"></div></div>;
};
// const userData = useRecoilValue(userDataState);
// //console.log("index js",userData);
const root = ReactDOM.createRoot(document.getElementById("root"));

console.log = () => {};
console.debug = () => {};
console.info = () => {};
console.warn = () => {};
console.error = () => {};
root.render(
  <> <RecoilRoot>
  <Suspense fallback={<Loading />}><LoadPages />  </Suspense>
  </RecoilRoot></>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
